'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
    // After user has seen the tracker intro they always go here
    .state('vnext.content.tracker', {
      url: 'tracker',
      abstract: true,
      template: '<ui-view />',
      data: {
        pageTitle: 'pageTitles.tracker'
      }
    })
    // Tracker intro for first time user accesses tracker
    .state('vnext.content.tracker.intro', {
      url: '/intro',
      templateUrl: 'tracker/templates/tracker-intro.html',
      abstract: true,
      default: '.welcome',
      controller: 'TrackerIntroCtrl',
      controllerAs: 'vm'
    }).state('vnext.content.tracker.intro.welcome', {
      url: '',
      templateUrl: 'tracker/templates/tracker-intro-1.html'
    }).state('vnext.content.tracker.intro.choose', {
      url: '/choose',
      templateUrl: 'tracker/templates/tracker-intro-2.html'
    }).state('vnext.content.tracker.intro.entry', {
      url: '/entry',
      templateUrl: 'tracker/templates/tracker-intro-3.html'
    })
    // After user has seen the tracker intro they always go here
    .state('vnext.content.tracker.main', {
      url: '',
      templateUrl: 'tracker/templates/tracker-main.html',
      abstract: true,
      default: '.chart',
      controller: 'TrackerCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.tracker'
      },
      resolve: {
        user: ['userSvc', function (userSvc) {
          return userSvc.getUser();
        }]
      },
      onEnter: ['user', '$state', function (user, $state) {
        if (!user.userPreferences.seenTrackerIntro || user.userPreferences.seenTrackerIntro !== 'true') {
          $state.go('vnext.content.tracker.intro');
        }
      }]
    }).state('vnext.content.tracker.main.entries', {
      url: '/entries',
      templateUrl: 'tracker/templates/tracker-entries.html',
      controller: 'TrackerEntriesCtrl',
      controllerAs: 'vm'
    }).state('vnext.content.tracker.main.chart', {
      url: '/chart',
      templateUrl: 'tracker/templates/tracker-charts.html',
      controller: 'TrackerChartsCtrl',
      controllerAs: 'vm',
      resolve: {
        translationReady: ['$translate', function ($translate) {
          return $translate.onReady(function () {
            return $translate('common.moodButtons.neither').then(function (res) {
              return res;
            });
          });
        }]
      }
    });
  }]);
})();